import { render, staticRenderFns } from "./ClaudeSetting.vue?vue&type=template&id=015a8dd4&"
import script from "./ClaudeSetting.vue?vue&type=script&lang=ts&"
export * from "./ClaudeSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports